"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.goal.efficiency': 'Efficienza',
    'slot.goal.accuracy': 'Precisione',
    'slot.goal.creativity': 'Creatività',
    'slot.goal.detail': 'Dettaglio',
};
